/**
 * SLL Product Card Dots
 * Standalone script — loaded via layout as a regular <script> tag.
 * Places media bars under the first block of product-card__content
 * and syncs them with Horizon's slideshow-component.
 */
(function() {
  if (window.__sllDotsReady) return;
  window.__sllDotsReady = true;

  /* ── Position bars after first child of product-card__content ── */
  function placeBars(card) {
    var bars = card.querySelector('.pcd-bars');
    if (!bars) return false;

    var content = card.querySelector('.product-card__content');
    if (!content || !content.firstElementChild) return false;

    var first = content.firstElementChild;
    if (first === bars) return true; // already placed

    first.after(bars);
    bars.classList.add('pcd-bars--placed');

    var gap = parseFloat(getComputedStyle(content).gap) || 0;
    if (gap > 0) bars.style.marginTop = '-' + gap + 'px';
    return true;
  }

  /* ── Sync dot active state with Horizon slideshow ── */
  function syncDots(card) {
    var bars = card.querySelector('.pcd-bars');
    if (!bars) return;
    var dots = bars.querySelectorAll('.pcd-bar');
    if (!dots.length) return;

    function highlight(idx) {
      for (var i = 0; i < dots.length; i++) {
        dots[i].classList.toggle('is-active', i === idx);
      }
    }

    // Horizon dispatches 'slideshow:select' with detail.index — it bubbles
    card.addEventListener('slideshow:select', function(e) {
      if (e.detail && typeof e.detail.index === 'number') highlight(e.detail.index);
    });

    // Also watch scroll on the scroller ref (mobile swipe)
    var ss = card.querySelector('slideshow-component');
    if (ss) {
      var scroller = ss.querySelector('[ref="scroller"]') || ss;
      var scrollTimer;
      scroller.addEventListener('scroll', function() {
        clearTimeout(scrollTimer);
        scrollTimer = setTimeout(function() {
          if (typeof ss.current === 'number') highlight(ss.current);
        }, 60);
      }, { passive: true });

      // Initial read
      function readNow() { if (typeof ss.current === 'number') highlight(ss.current); }
      readNow();
      setTimeout(readNow, 400);
      setTimeout(readNow, 1000);
    }
  }

  /* ── Init a single card ── */
  function initCard(card) {
    if (card.dataset.sllDots) return;
    card.dataset.sllDots = '1';

    var ok = placeBars(card);
    if (!ok) {
      var tries = 0;
      var id = setInterval(function() {
        tries++;
        if (placeBars(card) || tries > 40) {
          clearInterval(id);
          syncDots(card);
        }
      }, 150);
    } else {
      syncDots(card);
    }
  }

  /* ── Scan all cards on the page ── */
  function scanAll() {
    var cards = document.querySelectorAll('product-card, .product-card');
    for (var i = 0; i < cards.length; i++) initCard(cards[i]);
  }

  /* ── Bar click → navigate slideshow ── */
  document.addEventListener('click', function(e) {
    var bar = e.target.closest ? e.target.closest('.pcd-bar') : null;
    if (!bar) return;
    e.preventDefault();
    e.stopPropagation();

    var card = bar.closest('product-card, .product-card');
    if (!card) return;

    var idx = parseInt(bar.dataset.index, 10);
    var parent = bar.closest('.pcd-bars');
    var allBars = parent.querySelectorAll('.pcd-bar');
    for (var i = 0; i < allBars.length; i++) allBars[i].classList.toggle('is-active', i === idx);

    var ss = card.querySelector('slideshow-component');
    if (!ss) return;

    var slides = ss.querySelectorAll('slideshow-slide:not([hidden])');
    if (slides[idx]) {
      var sid = slides[idx].getAttribute('slide-id');
      if (sid && typeof ss.select === 'function') {
        try { ss.select({ id: sid }, undefined, { animate: true }); } catch(err) {}
        return;
      }
    }
    ss.setAttribute('initial-slide', String(idx));
  }, true);

  /* ── Desktop hover preview ── */
  document.addEventListener('mouseover', function(e) {
    if (!window.matchMedia('(hover: hover)').matches) return;
    var bar = e.target.closest ? e.target.closest('.pcd-bar') : null;
    if (bar) bar.click();
  });

  /* ── Boot ── */
  function boot() {
    scanAll();

    // MutationObserver for dynamically loaded cards (recommendations, etc.)
    new MutationObserver(function() { scanAll(); })
      .observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
